import { Activity } from '@/types';
import { getLowestPriceFromTiers } from '@/services/pricingService';

export type SortOption = 'distance' | 'price' | 'rating';

/**
 * Sorts an array of activities based on the specified sort option
 * @param activities - Array of activities to sort
 * @param sortBy - Sort option: 'distance', 'price', or 'rating'
 * @returns Sorted array of activities
 */
export const sortActivities = (
  activities: Activity[],
  sortBy: SortOption
): Activity[] => {
  const sorted = [...activities];

  switch (sortBy) {
    case 'distance':
      // Sort by distance (ascending), activities without distance go last
      return sorted.sort((a, b) => {
        // If neither has distance, maintain original order
        if (a.distanceFromSearch === undefined && b.distanceFromSearch === undefined) {
          return 0;
        }
        // Activities without distance go to the end
        if (a.distanceFromSearch === undefined) return 1;
        if (b.distanceFromSearch === undefined) return -1;
        // Sort by distance ascending
        return a.distanceFromSearch - b.distanceFromSearch;
      });

    case 'price':
      // Sort by price (ascending)
      return sorted.sort((a, b) => getLowestPriceFromTiers(a.priceTiers) - getLowestPriceFromTiers(b.priceTiers));

    case 'rating':
      // Sort by rating (descending - highest first)
      return sorted.sort((a, b) => b.rating - a.rating);

    default:
      return sorted;
  }
};

